import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconPreviousPage } from '../Icon'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_BLACK } from '../../lib/colors'
import { useNavigate } from 'react-router-dom'

const styles = StyleSheet.create({
  buttonContainer: {
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    borderStyle: 'none',
  },
  buttonLabel: {
    fontWeight: '600',
    fontSize: '14px',
    marginLeft: '10px',
  },
})

const UIBackButton = () => {
  const { t } = useTranslation('backButton')

  const navigate = useNavigate()

  return (
    <button
      className={css(styles.buttonContainer)}
      onClick={() => navigate(-1)}
    >
      <IconPreviousPage color={COLOR_BLACK} />
      <p className={css(styles.buttonLabel)}>{t('back')}</p>
    </button>
  )
}

export default UIBackButton
